export const useGetRangeFromAttrValue = (
  delta: any,
  attribute: string,
  value: string | boolean
) => {
  const ranges: { index: number; length: number }[] = [];
  let cursor = 0;
  let blockStart = 0; // Track where current block starts

  let run: { index: number; length: number } | null = null;

  for (const op of delta.ops ?? []) {
    const len = typeof op.insert === "string" ? op.insert.length : 1; // embeds count as 1
    const hasAttr = !!op.attributes && op.attributes[attribute] === value;

    // Check if this is a block-level operation (newline with attributes)
    const isBlockOp =
      typeof op.insert === "string" && op.insert.endsWith("\n") && hasAttr;

    if (isBlockOp) {
      // For block-level ops, capture the entire block range
      const blockLength = cursor - blockStart + len;
      ranges.push({ index: blockStart, length: blockLength });
      cursor += len;
      blockStart = cursor; // Next block starts after this newline
      run = null; // Reset any inline run
    } else if (hasAttr) {
      // For inline attributes
      if (!run) run = { index: cursor, length: 0 };
      run.length += len;
      cursor += len;
    } else {
      if (run) {
        ranges.push(run);
        run = null;
      }
      cursor += len;
    }

    // Track block boundaries (newlines)
    if (
      typeof op.insert === "string" &&
      op.insert.includes("\n") &&
      !isBlockOp
    ) {
      blockStart = cursor;
    }
  }

  if (run) ranges.push(run);
  return ranges;
};
